import {Component, Input, Output, EventEmitter} from '@angular/core';
import { AddLocationQuestionComponent } from "../../add-location-question/add-location-question.component";
import { MatDialog } from "@angular/material";
import * as L from 'leaflet';

@Component({
  selector: 'map-type',
  templateUrl: './map-type.component.html',
  styleUrls: ['./map-type.component.css']
})
export class MapTypeComponent {

  //Self explanatory

  @Input() question_index: number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() userRes : string[];
  @Input() indexOfRepeater : number;
  @Input() question_number : number;

  map_cord : string;
  response:string;
  err:string = '' ;

  map;
  markerOnMap:any;
  noLocationAdded = true;
  savedlat = null;
  savedlng = null;
  popupIcon = L.icon({
    iconUrl: 'assets/images/marker-unselected.svg',
  });

  constructor(public dialog: MatDialog){
  }

  ngOnInit() {
  }

  clicked(){
      this.getAddressOnMapDialog(this.savedlat,this.savedlng);
  }

  getAddressOnMapDialog(lat, lng){
    let dialogRef = this.dialog.open(AddLocationQuestionComponent,{
        data:{lat: lat, lng: lng},
        width: '100vw',
        height: '100vh',
        maxHeight:'100vh',
        maxWidth: '100vw'
      })

    dialogRef.afterClosed().subscribe((data)=>{
      if(data){
        let newLat =  data['latitude'];
        let newLng =  data['longitude'];
        this.savedlat =  data['latitude'];
        this.savedlng =  data['longitude'];
        this.addMap(newLat, newLng);
        this.map_cord = "Lat: " +  newLat  + " Lng: " +  newLng;
        this.response = "{\"lat\":" +  newLat  + ",\"lng\":" +  newLng + "}";
        this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
      }
    })
  }

  addMap(lat, lng){
    this.noLocationAdded = false;
    if(!this.map){
      this.map = L.map('mapQuestion' + this.question_index).setView([lat, lng], 13);
      L.tileLayer('http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        attribution: '',
        maxZoom: 25,
        id: 'mapbox/streets-v11',
        accessToken: 'your.mapbox.access.token'
      }).addTo(this.map);
    }
    if(this.markerOnMap){
      this.markerOnMap.remove();
    }
    this.markerOnMap = L.marker([lat,lng], {draggable: true}).setIcon(this.popupIcon).addTo(this.map);
    this.markerOnMap.on('dragend', (event)=>{
      var marker = event.target;
      var position = marker.getLatLng();
      this.savedlat = position['lat'];
      this.savedlng = position['lng'];
      this.map_cord = "Lat: " +  position['lat']  + " Lng: " +  position['lng'];
      marker.setLatLng(new L.LatLng(position.lat, position.lng),{draggable:true});
      this.map.setView(new L.LatLng(position.lat, position.lng), 8);
      this.response = "{\"lat\":" +  position['lat']  + ",\"lng\":" +  position['lng'] + "}";
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/app/questions-type/map/map-type.component.ts